export const useGlobalBannerStore = defineStore('globalBanner', {
  state: () => ({
    marketingBannerEnabled: false,
    uspBannerEnabled: false,
    globalBannerType: null,
    showUsps: false,
    marketingUspBlocks: [],
    uspBarBlocks: [],
    uspBlocks: [],
    benefitsEnabled: false,
    benefitBlocks: [],
    closableBannerEnabled: false,
    closableBlocks: [],
    countdownBanner: {},

    textForSavingsLabel: '',
    showSavingsLabelPDP: false,
    showSavingsLabelPLP: false,
    showSavingsLabelXSell: false,
  }),

  getters: {
    showBenefitsBanner: (state) => {
      return state.benefitsEnabled && state.benefitBlocks.length > 0;
    },
  },

  actions: {
    init({
      marketingBannerEnabled,
      globalBannerType,
      uspBarBlocks, // deprecated attribute
      benefitsEnabled,
      benefitBlocks,
      showUsps,
      marketingUspBlocks,
      textForSavingsLabel,
      showSavingsLabelPDP,
      showSavingsLabelPLP,
      showSavingsLabelXSell,
      countdownBanner,
    }) {
      this.marketingBannerEnabled = marketingBannerEnabled;
      this.globalBannerType = globalBannerType;
      this.showUsps = showUsps;
      this.marketingUspBlocks = marketingUspBlocks;
      this.uspBarBlocks = uspBarBlocks;
      this.benefitsEnabled = benefitsEnabled;
      this.benefitBlocks = benefitBlocks;
      this.countdownBanner = countdownBanner || {};

      this.textForSavingsLabel = textForSavingsLabel;
      this.showSavingsLabelPDP = showSavingsLabelPDP;
      this.showSavingsLabelPLP = showSavingsLabelPLP;
      this.showSavingsLabelXSell = showSavingsLabelXSell;
    },
  },
});
